import { Component } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { CommonUtilityHelper } from '@services/common-utility-helper/common-utility-helper';
import { AppConfig } from '../../app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { TimeService } from '@services/time-service';

@Component({
  selector: 'acquisition-waiting-for-call',
  templateUrl: './re-acquisition-waiting-for-call.html',
  standalone: false,
})

export class ReAcquisitionUserWaitingForCallComponent {
  isRebranding: boolean = false;
  constructor(
    private readonly conn: ConnectionService,
    private readonly eventLogger: EventLoggerService,
    public readonly appConfig: AppConfig,
    public readonly commonUtilityHelper: CommonUtilityHelper,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public readonly timeService: TimeService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.isRebranding = params['isRebranding'] === 'true';
    });
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_doctor_call_scheduled', type: 'full_screen' }));
  }

  back(): void {
    this.conn.navigateToURL('/user?tab=home', false, true);
  }

  submit(): void {
    if(this.isRebranding) {
      this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
      return;
    }
    this.conn.navigateToURL('/mainConcern', false, true);
  }
}
